export default {
  state: {
    title: 'Estado',
    visible: 'Pedidos à mesa visíveis',
    on: 'Pedidos à mesa',
  },
  notes: {
    hidden: {
      title: 'A encomenda à mesa está oculta',
      description:
        'Está ativa, mas a sua loja não a mostra, pelo que todos os pedidos à mesa são recusados. Ative «Encomenda à mesa visível» para a mostrar.',
      link: 'Ir para o interruptor',
    },
    off: {
      title: 'Os clientes não podem pedir à mesa neste momento',
      description:
        'Ative ambos os interruptores para começar. Até lá, o código QR de uma mesa abre a sua loja com Levantamento e Entrega.',
    },
    no_active_table: {
      title: 'Os clientes ainda não podem pedir à mesa',
      description: 'Adicione uma mesa abaixo e ative-a.',
    },
  },
  buttons: {
    save: 'Guardar',
  },
};
